function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icons/social/linkedin");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "icons/social/linkedin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M12,0 C18.6172174,0 24,5.38278261 24,12 C24,18.6172174 18.6172174,24 12,24 C5.38330435,24 0,18.6172174 0,12 C0,5.38278261 5.38330435,0 12,0 Z M9.092,16.683 L9.092,9.683 L6.569,9.683 L6.569,16.683 L9.092,16.683 Z M7.786,8.4 C8.643,8.4 9.157,7.886 9.157,7.2 C9.157,6.514 8.642,6 7.871,6 C7.014,6 6.5,6.514 6.5,7.2 C6.5,7.886 7.015,8.4 7.786,8.4 Z M18.092,16.683 L18.092,12.857 C18.092,10.66 17.115,9.683 15.894,9.683 C14.673,9.683 14.022,10.09 13.697,10.66 L13.697,9.683 L11.174,9.683 L11.174,16.683 L13.697,16.683 C13.697,16.683 13.697,13.02 13.697,12.857 C13.697,11.718 14.511,11.555 14.755,11.555 C14.999,11.555 15.65,11.799 15.65,12.857 L15.65,16.683 L18.092,16.683 Z",
  id: "Combined-Shape",
  fill: "#FD8C8C"
}));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.9ce780e3.svg";
export { ForwardRef as ReactComponent };